import React from 'react';
import ReactDOM from 'react-dom/client';
import {createBrowserRouter, RouterProvider} from "react-router-dom";

import Root from './Root';
import reportWebVitals from './reportWebVitals';
import PublicPage from './PublicPage';
import SSOPage from './SSOPage';
import HomePage from './HomePage';
import PublicEnhancedChatPage from './PublicEnhancedChatPage';
import AuthenticatedEnhancedChatPage from './AuthenticatedEnhancedChatPage';

import './index.css';
import ErrorPage from "./ErrorPage";

const router = createBrowserRouter([{
    path: '/',
    element: <Root/>,
    errorElement: <ErrorPage/>,
    children: [
        {
            index: true,
            element: <HomePage/>
        },
        {
            path: '/public',
            element: <PublicPage/>
        },
        {
            path: '/sso',
            element: <SSOPage/>
        },
        {
            path: '/public-enhanced-chat',
            element: <PublicEnhancedChatPage/>
        },
        {
            path: '/authenticated-enhanced-chat',
            element: <AuthenticatedEnhancedChatPage/>
        }
    ]
}]);
const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
    <React.StrictMode>
        <RouterProvider router={router}/>
    </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals(console.log);
